import { API_BASE_URL } from '..';
import {
  RequestResponseData,
  RequestResponseSubmit,
} from './RequestResponse.types';
import { publicInstance } from '@/api/axiosInstance';

const CONTROLLER_URL = `${API_BASE_URL}/requests-response`;

export async function requestResponseDetail(requestCode?: string) {
  const result = await publicInstance.get<RequestResponseData>(
    `${CONTROLLER_URL}/public/${requestCode}`,
  );

  return result.data;
}

export async function requestResponseSubmit(data: RequestResponseSubmit) {
  const result = await publicInstance.put<RequestResponseData>(
    `${CONTROLLER_URL}/public/${data.id}`,
    data,
  );

  return result.data;
}
